import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart } from '../../../actions/giftcard';

function RemoveGiftcardController() {
    const giftcards = useSelector(state => state.cart.giftcards);

    const dispatch = useDispatch();

    useEffect(() => {
        function onClick(e) {
            const target = e.target.closest('.remove-giftcard');
            if (!target) {
                return;
            }

            dispatch(removeFromCart(giftcards[target.dataset.index].id));
        }

        document.body.addEventListener('click', onClick);
    }, [giftcards]);

    return null;
}

export { RemoveGiftcardController };
